import React from "react";

import SearchPropertyCard from "../../enhancers/SearchPropertyCard";
import SearchPropertyPopup from "../../enhancers/SearchPropertyPopup";

import SearchBar from "./sections/search-bar";
import SearchView from "@coninsa-site/project/src/pages/search-view/search-view";
import Heading from "@coninsa-s2/heading";
import { CemtrickScript } from "@coninsa/cemtrick";
import { RentHousingFrequentSearch } from "../../sections/frequent-search/controller/RentHousingFrequentSearch";

import searchRentalHousingConfigs from "../../facets/search-rental-housing";

// 🔄 Normalizador de URLs para rental
const normalizeRentalUrl = (originalUrl: string) => {
  if (!originalUrl) return "#";

  // 👇 si trae "corretaje", siempre lo cambiamos por "arriendo"
  if (originalUrl.includes("corretaje")) {
    return originalUrl.replace("corretaje", "arriendo");
  }

  return originalUrl;
};


interface SearcRentalPageProps {
  navigate: (string) => void;
}

export const SearcRentalPage: React.FC<SearcRentalPageProps> = ({
  navigate = (url) => console.log(url),
}) => {
  return (
    <div>
      <SearchView
        navigate={navigate}
        searchBar={SearchBar}
        // 👇 Pasamos normalizeRentalUrl al Card
        itemCard={(props) => (
          <SearchPropertyCard {...props} normalizeUrl={normalizeRentalUrl} />
        )}
        popupCard={SearchPropertyPopup}
        configs={searchRentalHousingConfigs}
      />

      <div>
        <div className="container">
          <Heading
            as="h2"
            tint="teal"
            size="4xl"
            condensed
            className="lg:mt-16 lg-10"
          >
            Búsquedas <span className="is-highlighted">frecuentes</span>
          </Heading>
        </div>

        <RentHousingFrequentSearch title="Inmuebles de vivienda en arriendo" />
      </div>

      <CemtrickScript
        apiKey="AIzaSyCRpoXVEgJbf2thrXUp_kCLVLKEP7zt31U"
        code="97578cdd-ac94-4512-9c12-acb05f731ca6"
        triggers={{ exitIntent: true, timeOnPage: 180 }}
      />
    </div>
  );
};

export default SearcRentalPage;
